import {Component, OnInit, Input, OnChanges, AfterViewInit} from '@angular/core';
import {IVariantGrouping} from "../../Interfaces/IVariantGrouping";
import {IVariantGroupingType} from "../../Interfaces/IVariantGroupingType";
import {Scene7Helper} from "../../helpers/scene7.helper";
import TranslationsService from "../../../Common/Services/translations.service";


@Component({
    selector: 'kws-product-card-alt',
    templateUrl: './product-card-alt.component.html'
})
export class ProductCardAltComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() product: IVariantGrouping;
    @Input() variantGroupingTypes: IVariantGroupingType;
    finishes: any;
    comingSoon: boolean;

    constructor(public translationsService: TranslationsService) {
        this.translationsService = translationsService;
    }

    ngOnInit() {
        let avblDate = this.product.availableDate;
        let availableDate = new Date(avblDate); //dd-mm-YYYY
        let today = new Date();
        this.comingSoon = availableDate > today;
    }

    ngAfterViewInit() {

    }

    ngOnChanges() {
        const finishCount = this.product.finishes.length;
        this.finishes = `${finishCount} ${finishCount === 1 ? 'finish' : 'finishes'}`;
    }

    getProductDetailUrl() {
        if(this.product.variantSlug) {
            return `/products/detail/${this.product.slug}?variant=${this.product.variantSlug}`;
        } else {
            return `/products/detail/${this.product.slug}`;
        }
    }

    getProductImage(product) {
        if(product) {
            return Scene7Helper.imagePath(product, 'Kwikset', 'kwsProductLarge');
        } else {
            return Scene7Helper.imagePath('no-image', 'Kwikset', 'kwsProductLarge');
        }
    }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/components/product-card-alt/product-card-alt.component.ts